export const environment = {
    production: false,
    apiUrl: 'https://dev-api-mia.itsoftsrl.it/api'
};
